import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { Box, Flex, Text, Image, Button } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { Path } from 'config/constants/paths'

const FARM_BOOST_GITBOOK_URL = 'https://docs.vvs.finance/product-guides/boosted-farming'
export const storageKey = 'farm-boost'

export const FarmBoostBanner = ({ onCloseClick }) => {
  const { t } = useTranslation()
  const routerHistory = useHistory()

  return (
    <FarmBoostBannerCard>
      <MoleOnRocket />

      <ContentWrapper>
        <MobileTextsWrapper>
          <Text as="h3" color="white" fontSize="18px" fontWeight="700" mb="8px">
            {t('VVS Staking Utility v2')}
          </Text>
          <Text as="p" color="white">
            {t('Boost up to max. 2 farms')}
          </Text>
        </MobileTextsWrapper>
        <DesktopTextsWrapper>
          <BannerTitle as="h3" color="white" fontWeight="700">
            {t('VVS Staking Utility v2 is now LIVE!')}
          </BannerTitle>
          <Text as="p" color="white" fontSize="14px">
            {t('Deposit in xVVS vaults and stake Miner Moles to boost max. 2 farms’ APRs')}
          </Text>
        </DesktopTextsWrapper>
        <BtnsWrapper>
          <Button onClick={() => routerHistory.push(Path.VVS_FARM)}>{t('Boost')}</Button>
          <LearnMoreBtn
            variant="secondary"
            color="white"
            href={FARM_BOOST_GITBOOK_URL}
            onClick={() => window.open(FARM_BOOST_GITBOOK_URL, '_blank')}
          >
            {t('Learn More')}
          </LearnMoreBtn>
        </BtnsWrapper>
      </ContentWrapper>

      <CloseImageButton
        height={22}
        width={22}
        src="/images/vvsMinerMole/close_button.png"
        alt="close"
        onClick={onCloseClick}
      />
    </FarmBoostBannerCard>
  )
}

const FarmBoostBannerCard = styled(Flex)`
  border-radius: ${({ theme }) => theme.radii.card};
  width: 100%;
  padding: 0px;
  max-width: 1200px;
  align-self: stretch;

  background: linear-gradient(90deg, #002966 0%, #9476bd 75.91%, #be8e96 100%);
  position: relative;
  margin-top: 10px;
  margin-bottom: 28px;
  margin-left: 30px;
  margin-right: 30px;

  align-items: center;

  ${({ theme }) => theme.mediaQueries.md} {
    max-height: 120px;
  }
`

const MoleOnRocket = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('/images/xVVS/boost_mole.png');
  background-repeat: no-repeat;
  pointer-events: none;

  background-position: 90% 32%;
  background-size: auto 50%;
  ${({ theme }) => theme.mediaQueries.sm} {
    background-position: 90% 80%;
    background-size: auto 60%;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    background-position: 90% bottom;
    background-size: auto 90%;
  }
  ${({ theme }) => theme.mediaQueries.xxl} {
    background-position: 90% center;
    background-size: auto 100%;
  }
`
const ContentWrapper = styled(Flex)`
  flex: 1;
  align-self: stretch;
  padding: 20px 0 20px 30px;
  flex-direction: column;
  align-items: start;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 10px 30px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    flex-direction: row;
    align-items: center;
    padding: 0 30px;
  }
`

const MobileTextsWrapper = styled(Box)`
  flex: 1;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: none;
  }
`
const BtnsWrapper = styled(Flex)`
  gap: 15px;

  & > button {
    padding: 0 16px;
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    padding-right: 30px;
    & > button {
      height: 36px;
      padding: 0 12px;
    }
  }
  ${({ theme }) => theme.mediaQueries.md} {
    & > button {
      height: 48px;
      padding: 0 24px;
    }
  }
`
const DesktopTextsWrapper = styled(Box)`
  flex: 1;
  display: none;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: block;
  }
  ${({ theme }) => theme.mediaQueries.xl} {
    order: 1;
    padding-bottom: 10px;
  }
`
const CloseImageButton = styled(Image)`
  margin-right: 15px;
  cursor: pointer;
`

const BannerTitle = styled(Text)`
  font-weight: 700;
  font-size: 18px;
  ${({ theme }) => theme.mediaQueries.xl} {
    font-size: 24px;
  }
`
const LearnMoreBtn = styled(Button)`
  color: white;
  border-color: white;
`
